import RootState from 'ducks/RootState';

export const getBranding = (state: RootState) => state.branding;
